import React from 'react'
import BlurOrangeDecorationLarge from '../decorations/BlurOrangeDecorationLarge'
import BlurOrangeDecorationSmall from '../decorations/BlurOrangeDecorationSmall'
import BlurBlueDecorationSmall from '../decorations/BlurBlueDecorationSmall'

const HeaderDecoration = () => {
    return (
        <>
            <div className='position-absolute' style={{ top: '-106.46px', left: '-79.18px', zIndex: '-1' }}>
                <BlurOrangeDecorationLarge />
            </div>
            <div className='position-absolute d-none d-lg-block' style={{ top: '-99.39px', right: '10%', zIndex: '-1' }}>
                <BlurOrangeDecorationSmall />
            </div>
            <div className='position-absolute' style={{ top: '601.14px', left: '-56.72px', zIndex: '-1' }}>
                <BlurOrangeDecorationSmall />
            </div>
            <div className='position-absolute d-none d-lg-block' style={{ top: '222.96px', right: '-5%', zIndex: '-1' }}>
                <BlurBlueDecorationSmall />
            </div>
            <div className='position-absolute d-none d-lg-block' style={{ top: '705px', right: '-5%', zIndex: '-1' }}>
                <BlurOrangeDecorationSmall />
            </div>
        </>
    )
}

export default HeaderDecoration